import { FC, PropsWithChildren } from "react";

export const BlockButtonGroup: FC<PropsWithChildren> = ({ children }) => <div className="d-grid gap-2">{children}</div>;
